<script setup lang="ts">
import { useCompanyLogo } from "~ui/composables/useCompanyLogo"

const locales = useLocales()
const config = useRuntimeConfig()
const { data: companyLogoUrl } = await useCompanyLogo(
  `${config.public.apiBase}/public/v1`,
)
</script>
<template>
  <div class="overflow-hidden bg-zinc-50">
    <NotificationToast />
    <div class="relative mx-auto max-w-7xl">
      <div
        class="absolute -top-44 -right-60 h-60 w-[36rem] rotate-[-10deg] transform-gpu rounded-full bg-[linear-gradient(115deg,var(--tw-gradient-stops))] from-[#fff1be] from-28% via-[#ee87cb] via-70% to-[#b060ff] blur-3xl md:right-0"
      />
    </div>
    <div
      class="isolate flex min-h-dvh flex-col items-center justify-center gap-4 p-6 lg:p-8"
    >
      <div
        class="w-full max-w-md rounded-lg bg-white shadow-md ring-1 ring-black/5"
      >
        <div class="px-6 pt-6 sm:px-10 sm:pt-10">
          <div class="mb-6 flex flex-row items-center justify-between sm:mb-8">
            <NuxtLink :to="{ name: 'index' }" class="grow">
              <CompanyLogo v-if="companyLogoUrl" :url="companyLogoUrl" />
              <LogoSvg v-else class="size-12" />
            </NuxtLink>
            <div class="shrink">
              <LocaleSwitcher :locales class="w-full" />
            </div>
          </div>
          <slot name="heading" />
        </div>
        <slot />
      </div>
      <NuxtLink
        to="https://status.moxso.com"
        external
        class="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-500 hover:text-zinc-600"
        target="_blank"
      >
        <StatusDot />System status
      </NuxtLink>
    </div>
  </div>
</template>
